import React, { useEffect, useState, useMemo } from 'react';
import { observer } from 'mobx-react';
import type Trip from '@this/domain/trip/trip2';
import type OrderItem from '@this/domain/order_item2';
import { Fetcher } from '@this/src/util';

type Props = {
  trip: Trip;
  orderItem: OrderItem;
};

interface AiOperatorReservation {
  id: number;
  reservation_type: 'jal';
  trace_id: number;
  transport_element_id: number;
  status:
    | 'reservation_queue'
    | 'reserving'
    | 'reserved'
    | 'ticket_queue'
    | 'ticketing'
    | 'ticketed'
    | 'full'
    | 'failed';
  input_data: string;
  air_reservation_number: string | null;
  air_confirmation_number: string | null;
  started_at: string;
  finished_at: string | null;
  created_at: string;
  updated_at: string;
  failed_at: string | null;
  failure_reason: string | null;
  service_id: number;
}

interface AiOperatorResponse {
  result: AiOperatorReservation[];
}

export const OrderItemAioperatorInfo = observer(({ trip, orderItem }: Props) => {
  const [aiOperatorData, setAiOperatorData] = useState<AiOperatorResponse | null>(null);

  useEffect(() => {
    Fetcher.get<AiOperatorResponse>(
      `/arrangement/ai_operator_reservations/show_by_trip_id?trip_id=${trip.id}`
    ).then(res => {
      setAiOperatorData(res);
    });
  }, [trip.id]);

  const transportElementIds = useMemo(() => {
    return orderItem.transports.map(t => t.id);
  }, [orderItem]);

  const filteredData = useMemo(() => {
    if (!aiOperatorData?.result) return [];
    return aiOperatorData.result.filter(res => transportElementIds.includes(res.transport_element_id));
  }, [aiOperatorData, transportElementIds]);

  if (filteredData.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 style={{ marginBottom: '4px' }}>AI Operator予約</h3>
      {filteredData.map(res => (
        <div key={res.id}>
          <p>ステータス: {res.status}</p>
          <p>予約データ:</p>
          <p style={{ fontSize: '10px' }}>{res.input_data}</p>
        </div>
      ))}
    </div>
  );
});
